import ExecutiveHomeModule from './containers/executiveHomeModule'

export {default as ExecutiveHomeModuleLayout} from './components/executiveHomeModuleLayout'

export default ExecutiveHomeModule
